/*-- import aliases -----------
'!/...' -> project root
'~/...' -> js folder root
-----------------------------*/
import { setup } from '~/core';
setup();

import '~/global/_body';
import '~/global/_header';
import '~/global/_footer';
import '~/global/_siteModals';

import '~/components/_accordion';
import '~/components/_forms';
import '~/components/_activeOptions';
//import '~/components/_dateSpans';
import '~/components/_emailOptIn';
import '~/components/_newspaper';
import '~/components/_salesForceChat';
import '~/components/_videoLibrary';
import '~/components/_videoLibrarySearch';
import '~/components/_swiper';
import '~/components/_truncate';
import '~/components/_newPassword';
import '~/components/_passwordReset';

// import './ivolatilityIframe';
// import './iframeResizer.min';
